(function ($) {
  'use strict';

  /**
   * Nav Tray Controls
   */

  $.fn.menuTrayControls = function (args) {
    args = $.extend({
      target_el_ID: '',
      class_animate_in: 'is-animate-in--from-start',
      class_animate_out: 'is-animate-out--from-start',
      animation_length: 350,
      mobile_breakpoint: 760,
    }, args );
    var $button_control = $(this);
    var $site_wrap = $('body');
    var target_el_ID = args.target_el_ID;
    var class_animate_in = args.class_animate_in;
    var class_animate_out = args.class_animate_out;
    var animation_length = args.animation_length;
    var mobile_breakpoint = args.mobile_breakpoint;

    if ( target_el_ID === '' ) {
      target_el_ID = $button_control.attr('aria-controls');
    }

    var $menu_tray = $( '#' + target_el_ID );

    // Get all matching tray controls
    var $tray_controls = $( '[aria-controls="' + target_el_ID + '"]' );

    // Focusable els inside the tray.
    // Resolved on demand rather than cached here: this plugin runs before
    // mobile-menu.js builds its drill-down panels, so the back button and any
    // cloned sub-menu links don't exist yet. Panels also toggle `inert` as the
    // user drills in and out, which changes what's actually reachable.
    var FOCUSABLE_SELECTOR = 'a[href], button, input, select, textarea, [tabindex]';

    function get_focusable() {
      return $menu_tray
        .find( FOCUSABLE_SELECTOR )
        .filter( function () {
          if ( this.disabled ) {
            return false;
          }
          if ( this.getAttribute( 'tabindex' ) === '-1' ) {
            return false;
          }
          // Anything inside an inert subtree can't take focus. `inert` is a
          // reflected attribute, so the selector matches .prop('inert', true).
          if ( this.closest( '[inert]' ) ) {
            return false;
          }
          return true;
        } )
        .filter( ':visible' );
    }


    /**
     * Nav Tray Controls
     * ---
     */

    // Disable button during animations
    // *a11y - Not using `disabled` attr, so buttons retain focus
    var is_button_disabled = false;

    $tray_controls.on('click', function () {
      if ( is_button_disabled ) {
        return false;
      }
      is_button_disabled = true;

      toggleNavTray();

      setTimeout(function () {
        is_button_disabled = false;
      }, animation_length );
    });

    // Close on esc keypress
    $(document).on('keydown', function (e) {
      var is_tray_expanded = $button_control.attr('aria-expanded') === 'true';

      if ( e.key === 'Escape'
        && is_tray_expanded ) {
        closeNavTray();
      }
    });

    // Close if window is resized above `mobile_breakpoint`
    $(window).on('resize', function () {
      var is_tray_expanded = $button_control.attr('aria-expanded') === 'true';

      if ( $(window).width() > mobile_breakpoint
        && is_tray_expanded ) {
        closeNavTray();
      }
    });


    /**
     * Toggle / Open / Close
     */

    // Toggle Nav Tray
    function toggleNavTray() {
      var is_tray_expanded = $button_control.attr('aria-expanded') === 'true';

      if ( is_tray_expanded ) {
        closeNavTray();
      } else {
        openNavTray();
      }
    }

    // Expand tray
    function openNavTray() {

      // Update aria attrs
      $tray_controls.attr( 'aria-expanded', 'true' );
      $menu_tray.attr( 'aria-hidden', 'false' );

      // Lock site scroll
      $site_wrap.css( 'overflow', 'hidden' );

      // Slide Tray
      $menu_tray
        .removeClass( class_animate_out )
        .addClass( class_animate_in );

      // Wait for Slide Tray animation to finish
      setTimeout(function () {

        // Enable tabs
        $menu_tray.prop( 'inert', false );

        // Lock tabbing to focusable els inside tray + main menu
        lock_tab_focus();

        // Focus first el
        get_focusable().first().focus();

      }, animation_length );

      // // Sidebar Alignment Hack - Windows
      // // - Preserves space where sidebar shows & hides on Windows
      // // - (Breaks css `position: sticky` header)
      // $('.site-wrap').css('overflow-y', 'scroll');
    }

    // Collapse tray
    function closeNavTray() {
      // Update aria attrs
      $tray_controls.attr( 'aria-expanded', 'false' );
      $menu_tray.attr( 'aria-hidden', 'true' );

      // Slide Tray
      $menu_tray
        .removeClass( class_animate_in )
        .addClass( class_animate_out );

      // Unlock site scroll
      $site_wrap.css( 'overflow', 'auto' );

      // Unlock tabbing
      $menu_tray.prop( 'inert', true );
      unlock_tab_focus();

      // Focus back to header toggle button
      $button_control.focus();

      // // Sidebar Alignment Hack - Windows
      // // - Preserves space where sidebar shows & hides on Windows
      // // - Wait for Slide Tray animation to finish
      // // - (Breaks css `position: sticky` header)
      // setTimeout(function () {
      //   $('.site-wrap').css( 'overflow-y', 'initial' );
      // }, animation_length );
    }


    /**
     * Tab Locks
     */

    // Wrap Tab / Shift+Tab at the edges of the tray.
    // One delegated handler on the tray, rather than handlers bound to the
    // first and last elements — those go stale the moment the DOM changes
    // (drill-down panels, cloned sub-menu links, inert toggling).
    function on_tray_keydown( e ) {
      if ( e.key !== 'Tab' ) {
        return;
      }

      var $focusable = get_focusable();

      if ( ! $focusable.length ) {
        return;
      }

      var first  = $focusable.get( 0 );
      var last   = $focusable.get( $focusable.length - 1 );
      var active = document.activeElement;

      if ( e.shiftKey && active === first ) {
        last.focus();
        e.preventDefault();
      } else if ( ! e.shiftKey && active === last ) {
        first.focus();
        e.preventDefault();
      }
    }

    // Enable Tab Lock
    function lock_tab_focus() {
      $menu_tray.on( 'keydown.tablock', on_tray_keydown );
    }

    // Disable Tab Lock
    function unlock_tab_focus() {
      $menu_tray.off( '.tablock' );
    }

    return this;
  };

})(jQuery);
